import React from 'react';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import { Group, NumberField, Section } from '../controls';
import styles from './sections.module.css';

/** The node's top-left corner on the map. */
const PositionSection = ({ values, change }) => (
    <Section id="position" icon={<GpsFixedIcon />} title="Position">
        <div className={styles.grid}>
            <Group label="X">
                <NumberField title="Horizontal position" unit="px" value={values.x} onChange={(x) => change({ x })} />
            </Group>
            <Group label="Y">
                <NumberField title="Vertical position" unit="px" value={values.y} onChange={(y) => change({ y })} />
            </Group>
        </div>
    </Section>
);

export default PositionSection;
